import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { PreferredInterestPaymentTypeOptions } from '@apply/constants';
import { usePropertyPreferredInterestPaymentType } from '../../../../queries/PropertyFields/BridgeFields';

export interface PreferredInterestPaymentsProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const PreferredInterestPayments: React.FC<PreferredInterestPaymentsProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const label = 'Preferred Interest Payments';
    const infoBubbleText =
        'Accrual option increases interest rate by 0.5%. Accrual means no monthly payments; interest will accrue to the principal balance of the loan and be due at exit/maturity. Prior to an extension of the loan, accrual does not cause interest-on-interest. If the loan is extended, accrued and unpaid interest may be repaid or it will be capitalized to the loan balance. Thereafter, interest will be due monthly on the new loan balance.';
    const [preferredInterestPaymentType, set_preferredInterestPaymentType] =
        usePropertyPreferredInterestPaymentType(propertyGuid);

    const preferredInterestTermList = PreferredInterestPaymentTypeOptions.sort((o) => o.sortOrder).map((o) => ({
        display: o.name,
        value: o.id,
    }));

    const findPreferredInterestPaymentTypeByValue = (value: number | undefined) => {
        return preferredInterestTermList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findPreferredInterestPaymentTypeByValue(preferredInterestPaymentType)}
                />
            ) : (
                <DropDownBox
                    id={'preferredInterestPaymentTypeDropDown'}
                    value={preferredInterestPaymentType}
                    onChange={(value) => set_preferredInterestPaymentType(value)}
                    required={required}
                    dataSource={preferredInterestTermList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                    showInfoIcon={true}
                    infoText={infoBubbleText}
                />
            )}
        </>
    );
};
